module.exports = __webpack_public_path__ + "img/雪山入口.639d6d58.jpg";